export enum JobStatusesEnum {
  Unknown = 0,
  Draft = 100,
  InProgress = 200,
  Completed = 300
}
